var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDuration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.042,
    height: 7.042,
    viewBox: "0 0 7.042 7.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_material-timelapse",
    "data-name": "Icon material-timelapse",
    d: "M8.014,5.028a2.1,2.1,0,0,0-1.493-.62V6.521L5.028,8.014A2.111,2.111,0,1,0,8.014,5.028ZM6.521,3a3.521,3.521,0,1,0,3.521,3.521A3.522,3.522,0,0,0,6.521,3Zm0,6.338A2.817,2.817,0,1,1,9.338,6.521,2.816,2.816,0,0,1,6.521,9.338Z",
    transform: "translate(-3 -3)",
    fill: "rgba(0,0,0,0.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration);
export default __webpack_public_path__ + "static/media/icon-duration.56deae038fbf8fbec0971618b5d3f5dd.svg";
export { ForwardRef as ReactComponent };